/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import axios from "axios";
import baseUrl from "..";
import { authToken, authUserID, axiosInstance } from "../axiosConfig";



// Fetches media powder list for gpt test
const getMediaPowderListGpt = async (page: number, size: number, sort: any, order: any, keyword: any, lot?: string, mediaType?: string, fromDate?: string, toDate?: string) => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/media_powder/list?page=${page}&size=${size}&sort=${sort}&order=${order}${keyword ? `&keyword=${keyword}` : ''}&status=Quarantine${lot ? `&batch_name=${lot}` : ''}${mediaType ? `&media_name=${mediaType}` : ''}${fromDate ? `&from_date=${fromDate}` : ''}${toDate ? `&to_date=${toDate}` : ''}`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};


// Fetches media powder list for gpt test details
const getMediaPowderListDetailsGpt = async (page: number, size: number, sort: any, order: any, keyword: any, lot?: string, mediaType?: string, fromDate?: string, toDate?: string) => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/media_powder/list?page=${page}&size=${size}&sort=${sort}&order=${order}${keyword ? `&keyword=${keyword}` : ''}&status=Quarantine${lot ? `&id=${lot}` : ''}${mediaType ? `&media_name=${mediaType}` : ''}${fromDate ? `&from_date=${fromDate}` : ''}${toDate ? `&to_date=${toDate}` : ''}`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

//list organism types for dropdown in gpt test details page
const listOrganismTypes = async () => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/master/list_organism_types?sort=organism_type&order=asc&status=active`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};


//approve or reject gpt test for a batch
const saveGptTest = async (payload: any) => {
  try {
    const response = await axiosInstance.post(
      `${baseUrl}/gpt_test/save`,
      payload,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};


// fetch incubator list
const getIncubatorList = async () => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/equipments/list_all?sort=&order=desc&status=active&keyword=&process_id=8&id`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};


const uploadGptEvidenceFile = async (file: File) => {

  const formData = new FormData();
  formData.append("file", file);

  try {
    const response = await axiosInstance.post(
      `${baseUrl}/files/upload`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );

    return response.data;

  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};


export const gptTestService = {
  getMediaPowderListGpt,
  getMediaPowderListDetailsGpt,
  listOrganismTypes,
  saveGptTest,
  getIncubatorList,
  uploadGptEvidenceFile
};